import React from "react";
import { useEffect, useState } from "react";
import { CGetInterviewSchedule } from "../../../services/candidateService";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Modal, Button, Form, Toast, ToastContainer } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//Harshada Bhavsar - 25/7/2025
// Added the Get Interview Scheduled Candidate to Dashboard
const CGetInterviewScheduled = () => {
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [modalType, setModalType] = useState("");
  const [remark, setRemark] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showJobTitleFilter, setShowJobTitleFilter] = useState(false);
  const [filteredTitles, setFilteredTitles] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [searchTitleText, setSearchTitleText] = useState("");
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "success",
  });
  const [showCandidateModal, setShowCandidateModal] = useState(false);
  const navigate = useNavigate();
  const totalRecords = candidates.length;

  useEffect(() => {
    const GetInterviewScheduled = async () => {
      try {
        const response = await CGetInterviewSchedule();
        if (response) {
          setCandidates(response.data.interviewScheduledCandidates);
          console.log(response);
        }
      } catch (error) {
        console.log(error.response.data.message);
      } finally {
        setLoading(false);
      }
    };
    GetInterviewScheduled();
  }, []);
  const openModal = (candidate, type) => {
    setSelectedCandidate(candidate);
    setModalType(type);
    setRemark("");
  };

  const jobTitles = [...new Set(candidates.map((c) => c.jobTitel))];

  const handleFilterIconClick = () => {
    setShowJobTitleFilter(true);
    setFilteredTitles(jobTitles);
    setSelectedTitles(jobTitles);
    setSearchTitleText("");
  };

  const handleSearchTitleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTitleText(value);
    setFilteredTitles(
      jobTitles.filter((title) => title.toLowerCase().includes(value))
    );
  };

  const handleSelectTitle = (title) => {
    if (selectedTitles.includes(title)) {
      setSelectedTitles(selectedTitles.filter((t) => t !== title));
    } else {
      setSelectedTitles([...selectedTitles, title]);
    }
  };

  const handleSelectAllTitles = (checked) => {
    setSelectedTitles(checked ? jobTitles : []);
  };

  const filteredCandidates = candidates.filter(
    (candidate) =>
      (selectedTitles.length === 0 ||
        selectedTitles.includes(candidate.jobTitel)) &&
      [
        candidate.name,
        candidate.jobTitel,
        candidate.email,
        candidate.mobile,
        candidate.submitedBy,
        candidate.submitByType,
      ].some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [candidatesPerPage, setCandidatesPerPage] = useState(10);
  const indexOfLastCandidate = currentPage * candidatesPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
  const currentCandidates = filteredCandidates.slice(
    indexOfFirstCandidate,
    indexOfLastCandidate
  );
  const totalPages = Math.ceil(filteredCandidates.length / candidatesPerPage);
  const goToPage = (pageNumber) => setCurrentPage(pageNumber);
  const goToNext = () =>
    currentPage < totalPages && setCurrentPage((prev) => prev + 1);
  const goToPrev = () => currentPage > 1 && setCurrentPage((prev) => prev - 1);

  const hasCandidates = candidates.length > 0;

  const openCandidateModal = (candidate) => {
    setSelectedCandidate(candidate);
    setShowCandidateModal(true);
  };

  const closeCandidateModal = () => {
    setShowCandidateModal(false);
    setSelectedCandidate(null);
  };

  // Modal Open when Clicked on name
  const handleNameClick = (candidate) => {
    setSelectedCandidate(candidate);
    setShowCandidateModal(true);
  };
  return (
    <>
      <div className="jobs-container container mt-5 pt-5">
        <ToastContainer position="top-end" className="p-3">
          <Toast
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
            show={toast.show}
            delay={3000}
            autohide
          >
            <Toast.Body className="text-white fw-semibold">
              {toast.message}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        <div className="jobs-card shadow-sm">
          <div className="jobs-header d-flex justify-content-between align-items-center">
            <h3 className="fw-bold mb-0">Interview Schduled Candidates</h3>
          </div>

          {/* Search bar */}
          <div className="jobs-toolbar d-flex flex-wrap align-items-center gap-3 my-3 w-100">
            <div
              className="input-group rounded-pill border bg-white shadow-sm"
              style={{ maxWidth: "350px" }}
            >
              <span className="input-group-text bg-transparent border-0 ps-3">
                <i className="bi bi-search text-secondary"></i>
              </span>
              <input
                type="text"
                className="form-control border-0 rounded-5 shadow-none"
                placeholder="Search by name, title etc"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <div className="Overflow-Auto">
            {loading ? (
              <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
                <table className="table modern-table align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Job Title</th>
                      <th>Submited By</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(6)].map((_, rowIdx) => (
                      <tr key={rowIdx}>
                        {Array(7)
                          .fill()
                          .map((__, colIdx) => (
                            <td key={colIdx}>
                              <Skeleton height={20} />
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </SkeletonTheme>
            ) : (
              <table className="table modern-table align-middle">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      Job Title
                      <i
                        className="bi bi-caret-down-fill mx-2"
                        onClick={handleFilterIconClick}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </th>
                    <th>Submited By</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCandidates.length > 0 ? (
                    currentCandidates.map((candidate, index) => (
                      <tr key={candidate.id || index}>
                        <td>{indexOfFirstCandidate + index + 1}</td>
                        <td>{candidate.jobTitel}</td>
                        <td>
                          {candidate.submitedBy} ({candidate.submitByType})
                        </td>
                        <td
                          onClick={() => handleNameClick(candidate)}
                          className="text-primary fw-semibold"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {candidate.name}
                        </td>
                        <td>{candidate.email}</td>
                        <td>{candidate.mobile}</td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => openCandidateModal(candidate)}
                          >
                            <i className="bi bi-eye-fill"></i> View Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-danger py-3">
                        {hasCandidates
                          ? "No application found."
                          : "No new applications received."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination */}
          {totalRecords > 10 && (
            <div className="d-flex justify-content-end align-items-center mt-3 gap-3">
              <div className="d-flex align-items-center">
                <label className="me-2 fw-semibold">Items Per Page:</label>
                <Form.Select
                  className="form-select form-select-sm w-auto"
                  value={candidatesPerPage}
                  onChange={(e) => {
                    setCandidatesPerPage(parseInt(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </div>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      <i class="bi bi-chevron-left"></i>
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${
                        currentPage === idx + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(idx + 1)}
                      >
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* Job Title Filter Modal */}
          <Modal
            show={showJobTitleFilter}
            onHide={() => setShowJobTitleFilter(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Filter by Job Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Control
                type="text"
                placeholder="Search Job Titles"
                value={searchTitleText}
                onChange={handleSearchTitleChange}
                className="mb-2"
              />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedTitles.length === jobTitles.length}
                  onChange={(e) => handleSelectAllTitles(e.target.checked)}
                />
                <label className="form-check-label">Select All</label>
              </div>
              {filteredTitles.map((title, idx) => (
                <div className="form-check" key={idx}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedTitles.includes(title)}
                    onChange={() => handleSelectTitle(title)}
                    id={`job-title-${idx}`}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`job-title-${idx}`}
                  >
                    {title}
                  </label>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => setShowJobTitleFilter(false)}
              >
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      {/* --modal-- */}
      <Modal
        show={showCandidateModal}
        onHide={closeCandidateModal}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Candidate Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedCandidate ? (
            <>
              <div className="card mb-4 shadow-sm p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center mb-3">
                    {/* Candidate Name */}
                    <h5 className="mb-0 text-uppercase text-primary me-2">
                      {selectedCandidate.name || "-NA-"}
                    </h5>

                    {/* Status Badge */}
                    {selectedCandidate.status && (
                      <span className="badge btn-primary text-white">
                        <i className="bi bi-activity me-1"></i>
                        {selectedCandidate.status}
                      </span>
                    )}
                  </div>
                </div>

                <hr></hr>
                <div className="card-body">
                  {/* Other fields in 3 columns */}
                  <div className="row g-3">
                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-envelope text-info me-1"></i>
                        Email
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate?.email
                          ? selectedCandidate.email
                          : "- NA -"}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-telephone text-info me-1"></i>
                        Mobile
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate?.mobile
                          ? selectedCandidate.mobile
                          : "- NA -"}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-briefcase text-info me-1"></i>
                        Job Title
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate?.jobTitel
                          ? selectedCandidate.jobTitel
                          : "- NA -"}
                      </span>
                    </div>

                    <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-person-badge text-info me-1"></i>
                        Submitted By
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.submitedBy} (
                        {selectedCandidate.submitByType})
                      </span>
                    </div>

                    {/* <div className="col-md-4 col-12">
                      <p className="text-muted small mb-0">
                        <i className="bi bi-person-badge text-info me-1"></i>
                        DOB
                      </p>
                      <span className="fw-semibold small">
                        {selectedCandidate.dateOfBirth.split("T")[0]}
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p>No candidate data selected.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeCandidateModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* --end modal-- */}
    </>
  );
};
export default CGetInterviewScheduled;
